/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type PropsWithChildren, useEffect, useState } from 'react';

import { css, jsx } from '@compiled/react';

const MenuContainerWrapper = ({
	isSelected,
	isOpen,
	hasMenu,
	children,
	isOverflowing,
	isRenaming,
}: PropsWithChildren<{
	hasMenu?: boolean;
	isOpen?: boolean;
	isOverflowing?: boolean;
	isRenaming?: boolean;
	isSelected?: boolean;
}>) => {
	const [delayedIsOpen, setDelayedIsOpen] = useState(isOpen);
	useEffect(() => {
		if (!isOpen) {
			window.setTimeout(() => {
				// we need the menu trigger to stick around to allow focus to return to it when it is closed
				setDelayedIsOpen(false);
			}, 500);
		} else {
			setDelayedIsOpen(true);
		}
	}, [isOpen, setDelayedIsOpen]);

	const isOpenOrDelayed = isOpen || delayedIsOpen;
	const withMenu = hasMenu && !isRenaming;
	const withPeekMenu = withMenu && (isSelected || isOverflowing);

	return (
		<div
			css={[
				wrapperTabStyles,
				withMenu && isOpen && showingMenuStyles,
				withMenu && hoverMenuStyles,
				withPeekMenu && focusMenuStyles,
				withPeekMenu && isOpenOrDelayed && showingMenuStyles,
			]}
		>
			{children}
		</div>
	);
};

const wrapperTabStyles = css({
	'--display-icon-before': 'flex',
	'--display-menu': 'none',
});
const showingMenuStyles = css({
	'--display-icon-before': 'none',
	'--display-menu': 'block',
});

const focusMenuStyles = css({
	'&:focus-within': {
		'--display-icon-before': 'none',
		'--display-menu': 'block',
	},
});

const hoverMenuStyles = css({
	'&:hover': {
		'--display-icon-before': 'none',
		'--display-menu': 'block',
	},
});

export default MenuContainerWrapper;
